'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _semanticUiReact = require('semantic-ui-react');

var _demographicsAgeGraph = require('../demographics-age-graph');

var _demographicsAgeGraph2 = _interopRequireDefault(_demographicsAgeGraph);

var _followersBarChart = require('../followers-bar-chart');

var _followersBarChart2 = _interopRequireDefault(_followersBarChart);

var _locationTabs = require('./location-tabs');

var _locationTabs2 = _interopRequireDefault(_locationTabs);

var _authToken = require('../../utils/auth-token');

var _authToken2 = _interopRequireDefault(_authToken);

var _formatting = require('../../utils/formatting');

var _fullCityModal = require('./full-city-modal');

var _fullCityModal2 = _interopRequireDefault(_fullCityModal);

var _fullCountryModal = require('./full-country-modal');

var _fullCountryModal2 = _interopRequireDefault(_fullCountryModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cf = function cf(num) {
  return (0, _numeral2.default)(num).format('0,0');
};
var avgFormat = function avgFormat(num) {
  var entity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'posts';
  return _lodash2.default.isNil(num) || num === 0 ? 'no ' + entity : (0, _numeral2.default)(num).format('0,0');
};

var textCenterStyle = {
  textAlign: 'center',
  width: '100%'
};

var pageBreakStyle = {
  pageBreakBefore: 'always'
};

var notificationStyle = {
  paddingTop: 100,
  paddingBottom: 100
};

var noBorderStyle = (0, _extends3.default)({
  boxShadow: 'none',
  border: 'none'
}, pageBreakStyle);

var messageStyle = { color: 'grey', fontSize: 16 };
var pad5 = {
  padding: 5
};
var bgGrey = {
  backgroundColor: '#eee'
};

var pinkText = {
  color: '#e03997'
};

var pad50 = {
  paddingTop: 50
};

var fluid = {
  widht: '100%',
  display: 'block',
  textAlign: 'left'
};

var noMarginStyle = {
  margin: 0
};

var noVerticalMargin = {
  marginTop: 0,
  marginBottom: 0
};

var DaysStats = function DaysStats(_ref) {
  var loading = _ref.loading,
      insights = _ref.insights;

  var last14DaysPostsReachAvg = _lodash2.default.get(insights, 'last14DaysPostsReachAvg', '-');
  var last30DaysPostsReachAvg = _lodash2.default.get(insights, 'last30DaysPostsReachAvg', '-');

  var last14DaysPostsImpressionsAvg = _lodash2.default.get(insights, 'last14DaysPostsImpressionsAvg', '-');
  var last30DaysPostsImpressionsAvg = _lodash2.default.get(insights, 'last30DaysPostsImpressionsAvg', '-');

  var storiesStats = _lodash2.default.get(insights, 'storiesStats');

  var storiesPane = {
    menuItem: { key: 'stories', icon: 'circle outline', content: 'Stories' },
    render: function render() {
      return _react2.default.createElement(
        _semanticUiReact.Tab.Pane,
        null,
        _react2.default.createElement(
          'h5',
          { style: noVerticalMargin },
          'average reach'
        ),
        _react2.default.createElement(
          _semanticUiReact.Table,
          { basic: 'very', style: noMarginStyle },
          _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                '14 days'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { textAlign: 'center' },
                avgFormat(_lodash2.default.get(storiesStats, 'days14Reach', 0), 'stories')
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                '30 days'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { textAlign: 'center' },
                avgFormat(_lodash2.default.get(storiesStats, 'days30Reach', 0), 'stories')
              )
            )
          )
        ),
        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
        _react2.default.createElement(
          'h5',
          { style: noVerticalMargin },
          'average impressions'
        ),
        _react2.default.createElement(
          _semanticUiReact.Table,
          { basic: 'very', style: noMarginStyle },
          _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                '14 days'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { textAlign: 'center' },
                avgFormat(_lodash2.default.get(storiesStats, 'days14Impressions', 0), 'stories')
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                '30 days'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { textAlign: 'center' },
                avgFormat(_lodash2.default.get(storiesStats, 'days30Impressions', 0), 'stories')
              )
            )
          )
        )
      );
    } };

  var postsPane = {
    menuItem: { key: 'posts', icon: 'clone outline', content: 'Posts' },
    render: function render() {
      return _react2.default.createElement(
        _semanticUiReact.Tab.Pane,
        null,
        _react2.default.createElement(
          'h5',
          { style: noVerticalMargin },
          'average reach'
        ),
        _react2.default.createElement(
          _semanticUiReact.Table,
          { basic: 'very', style: noMarginStyle },
          _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                '14 days'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { textAlign: 'center' },
                avgFormat(last14DaysPostsReachAvg)
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                '30 days'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { textAlign: 'center' },
                avgFormat(last30DaysPostsReachAvg)
              )
            )
          )
        ),
        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
        _react2.default.createElement(
          'h5',
          { style: noVerticalMargin },
          'average impressions'
        ),
        _react2.default.createElement(
          _semanticUiReact.Table,
          { basic: 'very', style: noMarginStyle },
          _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                '14 days'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { textAlign: 'center' },
                avgFormat(last14DaysPostsImpressionsAvg)
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                '30 days'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { textAlign: 'center' },
                avgFormat(last30DaysPostsImpressionsAvg)
              )
            )
          )
        )
      );
    }
  };

  var panes = [postsPane];

  if (_lodash2.default.isNil(storiesStats)) {
    panes.push({
      menuItem: { key: 'stories', icon: 'circle outline', content: 'Stories' },
      render: function render() {
        return _react2.default.createElement(
          _semanticUiReact.Tab.Pane,
          null,
          _react2.default.createElement(
            'h5',
            { style: noVerticalMargin },
            'no stories data available yet.'
          )
        );
      }
    });
  } else {
    panes.unshift(storiesPane);
  }

  return _react2.default.createElement(
    'div',
    { style: fluid },
    loading && _react2.default.createElement(_semanticUiReact.Loader, { active: true, content: 'loading data' }),
    !loading && !insights && _react2.default.createElement(
      'span',
      null,
      'Failed to load data.'
    ),
    !loading && insights && _react2.default.createElement(_semanticUiReact.Tab, { panes: panes })
  );
};

var InstagramProfileData = function (_React$Component) {
  (0, _inherits3.default)(InstagramProfileData, _React$Component);

  function InstagramProfileData() {
    (0, _classCallCheck3.default)(this, InstagramProfileData);

    var _this = (0, _possibleConstructorReturn3.default)(this, (InstagramProfileData.__proto__ || (0, _getPrototypeOf2.default)(InstagramProfileData)).call(this));

    _this.componentDidMount = function () {
      var influencer = _this.props.influencer;

      _this.api.get('/instagram/' + influencer.instagram + '/history').then(function (response) {
        var items = response.data.items;

        return _this.setState({
          items: _lodash2.default.reverse(items),
          loading: false
        });
      });

      _this.instagramApi.get('stats/' + influencer.instagram).then(function (response) {
        var data = response.data.data;

        return _this.setState({
          isLoadingStats: false,
          instagramStats: data
        });
      });

      if (influencer.instagramData) {
        _this.reachApi.get(influencer.id + '/instagram/insights').then(function (response) {
          var data = response.data.data;

          return _this.setState({
            insights: data,
            isLoadingInsights: false
          });
        }).catch(function () {
          _this.setState({
            insights: null,
            isLoadingInsights: false
          });
        });
      }
    };

    _this.toggleFullCityModal = function () {
      var fullCityModalOpen = _this.state.fullCityModalOpen;

      return _this.setState({
        fullCityModalOpen: !fullCityModalOpen
      });
    };

    _this.toggleFullCountryModal = function () {
      var fullCountryModalOpen = _this.state.fullCountryModalOpen;

      return _this.setState({
        fullCountryModalOpen: !fullCountryModalOpen
      });
    };

    _this.state = {
      insights: null,
      isLoadingStats: true,
      isLoadingInsights: true,
      items: [],
      loading: true,
      oneDay: true
    };
    var token = (0, _authToken2.default)();
    var newsfeedApi = 'https://b7o8doqzfb.execute-api.eu-west-1.amazonaws.com/production';
    var instagramDataApi = 'https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/influencer';
    var reachAndImpressionsApi = 'https://uiqcrs8dhb.execute-api.eu-west-1.amazonaws.com/production/influencer';

    _this.api = _axios2.default.create({
      baseURL: newsfeedApi,
      timeout: 10000,
      headers: {
        Authorization: 'Bearer ' + token
      }
    });
    _this.instagramApi = _axios2.default.create({
      baseURL: instagramDataApi,
      timeout: 10000,
      headers: {
        Authorization: 'Bearer ' + token
      }
    });

    _this.reachApi = _axios2.default.create({
      baseURL: reachAndImpressionsApi,
      timeout: 20000,
      headers: {
        Authorization: 'Bearer ' + token
      }
    });
    return _this;
  }

  (0, _createClass3.default)(InstagramProfileData, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          influencer = _props.influencer,
          disableBorders = _props.disableBorders,
          usedByACRCampaign = _props.usedByACRCampaign,
          organisationId = _props.organisationId,
          displayAuthorisedData = _props.displayAuthorisedData;
      var _state = this.state,
          items = _state.items,
          insights = _state.insights,
          loading = _state.loading,
          instagramStats = _state.instagramStats,
          isLoadingInsights = _state.isLoadingInsights,
          isLoadingStats = _state.isLoadingStats,
          fullCityModalOpen = _state.fullCityModalOpen,
          fullCountryModalOpen = _state.fullCountryModalOpen;
      var instagramEngagementRate = influencer.instagramEngagementRate;
      var instagramData = influencer.instagramData;

      var igDataExists = _lodash2.default.size(instagramData) > 0;

      var instagram = influencer.instagram,
          instagramThumbnail = influencer.instagramThumbnail;


      var hasInstagramHandle = _lodash2.default.isString(instagram);
      var hasEnoughData = true;

      var graphData = {
        label: 'followers',
        labels: _lodash2.default.map(items, function (item) {
          return (0, _moment2.default)(item.createdAt).format('MMM D');
        }),
        values: _lodash2.default.map(items, 'followerCount')
      };

      var lastItem = _lodash2.default.last(items);
      var percentageChange = void 0;
      var followersInLast30Days = 0;

      var thirtyDaysAgo = (0, _moment2.default)().subtract('days', 30);
      var last30DaysPosts = _lodash2.default.filter(items, function (item) {
        var createdDate = (0, _moment2.default)(item.createdAt);
        return createdDate.isAfter(thirtyDaysAgo);
      });

      if (!loading && last30DaysPosts.length > 0) {
        var first = _lodash2.default.head(last30DaysPosts).followerCount;
        var last = _lodash2.default.last(last30DaysPosts).followerCount;
        percentageChange = (last - first) / first;
        followersInLast30Days = last - first;
      }

      var canViewPrivateData = displayAuthorisedData || usedByACRCampaign;

      return _react2.default.createElement(
        _semanticUiReact.Segment,
        {
          loading: loading,
          color: disableBorders ? '' : 'pink',
          style: disableBorders ? noBorderStyle : pageBreakStyle
        },
        _react2.default.createElement(
          'h3',
          null,
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram', color: 'pink' }),
          'Instagram'
        ),
        _react2.default.createElement(_semanticUiReact.Divider, null),
        influencer && influencer.instagramPrivate && _react2.default.createElement(
          _semanticUiReact.Message,
          { icon: true, warning: true },
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock' }),
          _react2.default.createElement(
            _semanticUiReact.Message.Content,
            null,
            _react2.default.createElement(
              _semanticUiReact.Message.Header,
              null,
              'Private account'
            ),
            'This Instagram account is private'
          )
        ),
        !lastItem && _react2.default.createElement(
          _semanticUiReact.Message,
          { icon: true, warning: true },
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'area graph' }),
          _react2.default.createElement(
            _semanticUiReact.Message.Content,
            null,
            'Instagram stats not available yet, please come back later'
          )
        ),
        lastItem && _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 3 },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 3 },
              hasInstagramHandle && !loading && _react2.default.createElement(
                'div',
                { style: pad50 },
                _react2.default.createElement(_semanticUiReact.Image, {
                  src: instagramThumbnail || lastItem.profilePic,
                  className: 'circular',
                  centered: true,
                  size: 'small'
                }),
                _react2.default.createElement(
                  _semanticUiReact.Table,
                  { basic: 'very', fluid: true, textAlign: 'center' },
                  _react2.default.createElement(
                    _semanticUiReact.Table.Body,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        lastItem.handle,
                        '\xA0',
                        lastItem.isVerified && _react2.default.createElement(_semanticUiReact.Popup, {
                          trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', color: 'blue' }),
                          content: 'verified account'
                        }),
                        '\xA0',
                        _react2.default.createElement(_semanticUiReact.Popup, {
                          trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'briefcase', color: lastItem.isBusinessAccount ? 'pink' : 'grey' }),
                          content: (lastItem.isBusinessAccount ? '' : 'Not an') + ' Instagram business account'
                        }),
                        influencer && influencer.instagramPrivate && _react2.default.createElement(_semanticUiReact.Popup, {
                          trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock', color: 'red' }),
                          content: 'This account is private'
                        })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        cf(lastItem.followerCount),
                        ' followers'
                      )
                    ),
                    !lastItem.isVerified && _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        _react2.default.createElement(_semanticUiReact.Popup, {
                          trigger: _react2.default.createElement(_semanticUiReact.Label, { basic: true, color: 'grey', content: 'not verified' }),
                          content: lastItem.handle + ' is not verified by Instagram (blue tick)'
                        })
                      )
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 8 },
              !hasInstagramHandle && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  _semanticUiReact.Header,
                  { as: 'h2', icon: true, textAlign: 'center', style: notificationStyle },
                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'minus', color: 'orange', circular: true }),
                  _react2.default.createElement(
                    _semanticUiReact.Header.Content,
                    { style: messageStyle },
                    'no Instagram channel for this influencer'
                  )
                )
              ),
              hasInstagramHandle && !hasEnoughData && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  _semanticUiReact.Header,
                  { as: 'h2', icon: true, textAlign: 'center', style: notificationStyle },
                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'clock', color: 'orange', circular: true }),
                  _react2.default.createElement(
                    _semanticUiReact.Header.Content,
                    { style: messageStyle },
                    'we have not collected enough ',
                    _react2.default.createElement('br', null),
                    ' data for this channel yet'
                  )
                )
              ),
              hasInstagramHandle && hasEnoughData && _react2.default.createElement(
                'div',
                { className: 'chart-wrapper-print' },
                _react2.default.createElement(_followersBarChart2.default, (0, _extends3.default)({}, graphData, {
                  percentageRange: 0.5
                }))
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 5 },
              hasInstagramHandle && isLoadingStats && _react2.default.createElement(_semanticUiReact.Loader, { active: true, content: 'Loading...' }),
              hasInstagramHandle && instagramStats && !isLoadingStats && _react2.default.createElement(
                'div',
                null,
                instagramEngagementRate && _react2.default.createElement(
                  _semanticUiReact.Statistic,
                  { style: textCenterStyle },
                  _react2.default.createElement(
                    _semanticUiReact.Statistic.Value,
                    null,
                    (0, _formatting.ierFormat)(instagramEngagementRate),
                    '%'
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Statistic.Label,
                    null,
                    'engagement rate'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table,
                  { basic: 'very', fluid: true, compact: true },
                  _react2.default.createElement(
                    _semanticUiReact.Table.Body,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        '30 day trend'
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        _react2.default.createElement(_semanticUiReact.Label, {
                          basic: true,
                          color: percentageChange > 0 ? 'green' : 'red',
                          content: (0, _numeral2.default)(percentageChange).format('+0.0%')
                        })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        'avg. likes per post'
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        cf(instagramStats.likesPerPost)
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        'avg. comments per post'
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        cf(instagramStats.commentsPerPost)
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        'avg. engagements per post'
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        cf(instagramStats.engagementsPerPost)
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        'posts per week'
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        cf(instagramStats.average7DaysPosts)
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        'posts per month'
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        cf(instagramStats.average30DaysPosts)
                      )
                    )
                  )
                )
              )
            )
          ),
          canViewPrivateData && igDataExists && _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { textAlign: 'center' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(
                'h2',
                null,
                'Audience Demographics and Regions',
                _react2.default.createElement(_semanticUiReact.Popup, {
                  trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock', color: 'orange' }),
                  content: 'Private data collected from Instagram Insights API'
                })
              )
            )
          ),
          canViewPrivateData && igDataExists && _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { textAlign: 'center' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 3 },
              _react2.default.createElement(DaysStats, { loading: isLoadingInsights, insights: insights })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 8 },
              _react2.default.createElement(
                'h5',
                null,
                'Channel demographic by gender / age'
              ),
              _react2.default.createElement(
                'div',
                { className: 'chart-wrapper-print' },
                _react2.default.createElement(_demographicsAgeGraph2.default, instagramData)
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 5 },
              _react2.default.createElement(_locationTabs2.default, (0, _extends3.default)({}, instagramData, {
                onFullCityClick: this.toggleFullCityModal,
                onFullCountryClick: this.toggleFullCountryModal
              })),
              fullCityModalOpen && _react2.default.createElement(_fullCityModal2.default, (0, _extends3.default)({}, instagramData, { onToggle: this.toggleFullCityModal })),
              fullCountryModalOpen && _react2.default.createElement(_fullCountryModal2.default, (0, _extends3.default)({}, instagramData, {
                onToggle: this.toggleFullCountryModal
              }))
            )
          )
        )
      );
    }
  }]);
  return InstagramProfileData;
}(_react2.default.Component);

InstagramProfileData.propTypes = {
  influencer: _propTypes2.default.object.isRequired,
  loading: _propTypes2.default.bool.isRequired,
  disableBorders: _propTypes2.default.bool,
  usedByACRCampaign: _propTypes2.default.bool,
  displayAuthorisedData: _propTypes2.default.bool
};

InstagramProfileData.defaultProps = {
  disableBorders: false,
  usedByACRCampaign: false,
  displayAuthorisedData: false
};

exports.default = InstagramProfileData;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/instagram-profile-data/index.js
 ** module id = 377
 ** module chunks = 0
 **/